// pages
import Index5 from "../pages/Index5"

const routes = [
    { path: "/", component: <Index5 /> },
]

export { routes };